const NS = 'TabContainerBlock';
const CLS = 'tabContainerBlock';

export class TabContainerBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$tabs = this.$element.find(`.${CLS}-tab-list`);
		this.$tabPanes = this.$element.find(`.${CLS}-tab-pane`);
		this.renderTabs();
	}

	renderTabs() {
		let tabListTemplate = () => {
			let value = '';

			let tabItemTemplate = (tab) => {
				// Tab List HTML element
				return `<li class="${CLS}-tab-item nav-item">
					<a class="${CLS}-tab-link nav-link ${tab.isActive ? 'active' : ''}" data-key="${tab.id}" data-toggle="tab" data-target="#${tab.id}" href="javascript:void(0);">
						${(() => {
							return tab.iconSrc ? `<span class="${CLS}-tab-link-icon nav-link-icon" style="background-image: url(${tab.iconSrc})"></span>`: '';
						})()}
						<span>${tab.title}</span>
					</a>
				</li>`;
			};

			this.$tabPanes.each((index, element) => {
				let $element = $(element);
				let config = {};
				config.isActive = $element.hasClass('active') ? true : false;
				config.id = $element.attr('id');
				config.title = $element.attr('data-title');
				config.iconSrc = $element.attr('data-icon-src');

				value += tabItemTemplate(config);
			});

			return value;
		};

		this.$tabs.append(tabListTemplate());
	}
}


